import { store } from '@/app/store';
import { scheduleMeeting } from '@/features/calls/services/callService';
import { updateInviteStatus } from '@/features/invite/model/inviteSlice';
import { getInviteRequestInfo } from '@/infrastructure/sdk/invite';
import { getUserIdFromJid, logger } from '@/shared/utils';
import { MessageService } from './messageService';

export const syncInviteStatusOnSend = async recipientJid => {
   const userId = getUserIdFromJid(recipientJid);
   const info = (await getInviteRequestInfo(recipientJid))?.data;
   if (!info) return;
   store.dispatch(
      updateInviteStatus({
         userId,
         inviteStatus: info.inviteStatus,
         isSender: info.isSender,
         remainingMessages: info.remainingMessages,
      }),
   );
};

export const dispatchTextMessage = async ({ msgId, msgBody }, recipientJid) => {
   const { message: messageText, mentionedUsersIds = [], replyTo: replyMessageId = '' } = msgBody;
   try {
      const res = await MessageService.sendText({
         toJid: recipientJid,
         messageText,
         msgId,
         replyMessageId,
         mentionedUsersIds,
      });
      logger.log(res);
      if (res?.statusCode === 200) await syncInviteStatusOnSend(recipientJid);
   } catch (err) {
      logger.error(`[MessageDispatch] Text failed (${msgId}):`, err);
      throw err;
   }
};

export const dispatchMeetMessage = async ({ msgId, msgBody, fromUserJid: toJid }) => {
   const { title, link, scheduledDateTime } = msgBody?.meet || {};
   try {
      await scheduleMeeting({ toJid, msgId, title, link, scheduledDateTime });
   } catch (err) {
      logger.error(`[MessageDispatch] Meet failed (${msgId}):`, err);
      throw err;
   }
};

export const dispatchEditMessage = async ({ editMessageId, msgId, msgBody }) => {
   const { message: editedTextContent, mentionedUsersIds = [], media } = msgBody;
   try {
      if (media) {
         await MessageService.editCaption({
            newEditMessageId: editMessageId,
            messageId: msgId,
            editedTextContent: media.caption,
            mentionedUsersIds,
         });
      } else {
         await MessageService.editText({
            newEditMessageId: editMessageId,
            messageId: msgId,
            editedTextContent,
            mentionedUsersIds,
         });
      }
   } catch (err) {
      logger.error(`[MessageDispatch] Edit failed (${msgId}):`, err);
      throw err;
   }
};
